export const LatestBrowserVersions = {
    'Chrome': 73,
    'Firefox': 66,
    'Opera': 58,
    'Safari': 12,
    'MS-Edge': 17,
    'IE': 11
};